import { reactive , computed } from 'vue'
import axios from 'axios'
import Util from '../../lib/util'
// import Config from '../../config'
// import Util from '../../lib/util'

// state
const state = reactive({
  //プレビューモード:true
  preview:false,

  //固定オブジェクトのjsonデータ
  mapdata:{},

  //apiより取得したspots一覧データ
  spots:[],

  //apiより取得したspot記事データ
  spot:{},

  //1:広域,2:山頂本堂中域,3:山頂本堂詳細,4:鳳凰殿中域,5:鳳凰殿詳細
  maptypePattern:[1,2,3,4,5],
  
  //computedにてspots一覧をmaptype毎に区分する
  spotsEveryMapType:computed(()=>{
    const dict = {}
    state.maptypePattern.forEach(v => {
      dict[v] = []
    })
    state.spots.forEach(v => {
      if(typeof dict[v.maptype] === 'undefined'){
        dict[v.maptype] = []
      }
      dict[v.maptype].push(v)
    })

    //並び替え
    Object.keys(dict).forEach((key)=>{
      dict[key].sort(_sortCoordinate)
    })

    Object.keys(dict).forEach((key)=>{
      dict[key].forEach((v,i)=>{
        v._order = i
      })
    })
    return dict
  }),

  //idにてspotsデータを検索する
  spotsSearchById:(id)=>{
    const arr = state.spots.filter(d => d.id == id)
    return arr.length > 0 ? arr[0] : null
  },

  //to_maptypeにてmaptypeデータを検索する
  mapdataSearchByToMaptype:(to_maptype,maptype)=>{
    if(state.mapdata[maptype]){
      const arr = state.mapdata[maptype].filter(d => d.type == 'maptypebtn' && d.to_maptype == to_maptype)
      return arr.length > 0 ? arr[0] : null
    } else {
      return null
    }
  },

  countMapDataItem:(maptype,type)=>{
    if(state.mapdata[maptype]){
      const arr = state.mapdata[maptype].filter(d => d.type == type)
      return arr.length
    } else {
      return 0
    }
  },

  countSpotsItem:(maptype)=>{
    return state.spotsEveryMapType[maptype].length
  },
})


/**
 * プレビュー状態を更新する
 */
function initPreview(){
  let preview = false
  if(window && window.option && window.option.preview){
    preview = window.option.preview ? true : false
  }
  state.preview = preview
}



/**
 * マップの固定オブジェクトデータを取得する
 */
async function initMapData(){
  state.maptypePattern.forEach(async (v)=>{
    let res
    res = await _getApiJson('map-items-maptype'+ v +'.json','/static/mapdata/')
    if(typeof res.data === 'object'){
      if(res.data.response.success == 1){
        let data = res.data.data

        data.sort(_sortCoordinate)

        let _orderObject = 0
        let _orderMaptypebtn = 0
        data.forEach((v,i)=>{
          if(v.type == 'object'){
            v._order = _orderObject
            _orderObject++
          } else if(v.type == 'maptypebtn'){
            v._order = _orderMaptypebtn
            _orderMaptypebtn++
          }
        })

        state.mapdata[v] = data
      } else {
        console.log(res.data.response.message,'map-items-maptype'+ v +'.json');
      }
    } else {
      console.error('JSON PARSE ERROR 正しいJSON形式データか確認してください。 : map-items-maptype'+ v +'.json');
    }
  })
}


/**
 * spot一覧を取得する
 */
async function initSpots(){
  let res
  if(process.env.VUE_APP_API_DEBUG == 'yes'){
    res = await _getApiJson('spots.json')
  } else {
    res = await _getApiServer('api/spots',{
      preview:state.preview
    })
  }
  if(res.data.response.success == 1){
    state.spots = res.data.data
  } else {
    console.log(res.data.response.message);
  }
}

/**
 * spot詳細を取得する
 */
 async function initSpot(id){
  let res
  if(process.env.VUE_APP_API_DEBUG == 'yes'){
    res = await _getApiJson('spot.json')
  } else {
    res = await _getApiServer('api/spot',{
      preview:state.preview,
      id:id,
    })
  }
  if(res.data.response.success == 1){
    state.spot[id] = res.data.data
  } else {
    console.log(res.data.response.message);
  }
}

/**
 * spot詳細データを取得する
 */
 function getSpotById(id){
  if(state.spot[id]){
    return state.spot[id]
  } else {
    return {}
  }
}


//=============================
//
// ローカル関数
//
//=============================

const _getApiServer = async (endpoint,params)=>{
  let domain = process.env.VUE_APP_URL
  if(window.location.hostname == 'xs893099.xsrv.jp'){
    domain = process.env.VUE_APP_URL_DEVELOPMENT
  }
  const path = domain + endpoint
  try {
    let res = await axios.get(path,{
      params:params,
      // auth: { username: 'krkr', password: '11223344' },
      // withCredentials:true
    })
    return res
  } catch (error) {
    return {
      data:{
        response: {
          success: 0,
          message: 'PATH:' + path + ' ' +error.toString()
        }
      }
    }
  }
}

const _getApiJson = async (filename,dir='')=>{
  if(!dir){
    dir = '_apijson/'
  }
  const path = dir + filename
  try {
    let res = await axios.get(path)
    return res
  } catch (error) {
    return {
      data:{
        response: {
          success: 0,
          message: 'PATH:' + path + ' ' +error.toString()
        }
      }
    }
  }
}

/**
 * 座標にてソートする
 */
const _sortCoordinate = (a,b)=>{
  const coordinateA = a.coordinate.split(",")
  const coordinateB = b.coordinate.split(",")
  const xA = Number(coordinateA[0])
  const xB = Number(coordinateB[0])
  if(xA > xB){
    return 1
  } else if(xA < xB){
    return -1
  } else {
    return 0
  }
}


export default {
  namespaced: true,
  state,
  initPreview,
  initMapData,
  initSpots,
  initSpot,
  getSpotById,
}
